import React from 'react';

const Password = ({ className, fill }) => {
  return (
<svg version="1.0"   className={className}  xmlns="http://www.w3.org/2000/svg"
 width="75.000000pt" height="75.000000pt" viewBox="0 0 75.000000 75.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,75.000000) scale(0.100000,-0.100000)"
fill={fill} stroke="none">
<path d="M310 642 c-53 -26 -80 -74 -80 -143 l0 -58 -42 -3 -43 -3 0 -170 0
-170 230 0 230 0 0 170 0 170 -42 3 -43 3 0 58 c0 44 -6 66 -23 92 -26 39 -79
69 -122 69 -16 0 -46 -8 -65 -18z m128 -38 c33 -23 52 -67 52 -119 l0 -45
-115 0 -115 0 0 45 c0 84 44 135 115 135 22 0 51 -7 63 -16z m142 -339 l0
-135 -205 0 -205 0 0 135 0 135 205 0 205 0 0 -135z"/>
</g>
</svg>
)
}
export default Password;